export default "__VITE_ASSET__a07134a4__"